import cn from 'classnames'
import type { MouseEvent, ReactNode } from 'react'

type ExpenseTabProps = {
  active: boolean
  caption: ReactNode
  count?: number
  onClick: (event: MouseEvent<HTMLDivElement>) => void
}

export const ExpenseTab = ({ active, caption, count, onClick }: ExpenseTabProps) => (
  <span className={cn('tab', { active })} onClick={onClick}>
    <span>{caption}</span>
    {count ? <span className='badge'>{count}</span> : null}
  </span>
)
